import { Component, OnInit } from "@angular/core";
import { Company } from "src/app/ui/models/domains/pbm/companies/company";
import { TopTenNetworksIndicatorData } from "src/app/ui/models/domains/pbm/indicators/top-ten-networks-data";
import { TopTenNetworksIndicatorDataStrategy } from "src/app/ui/pages/home/indicator-data-strategies";
import { IndicatorMediator } from "src/app/ui/services/pbm/indicator-mediator";
import { IndicatorService } from "src/app/ui/services/pbm/indicator.service";

@Component({
  selector: "top-ten-networks-indicator",
  templateUrl: "./top-ten-networks-indicator.component.html",
  styleUrls: ["./top-ten-networks-indicator.component.scss"],
})
export class TopTenNetworkIndicatorComponent implements OnInit {
  public topTenNetworksData: TopTenNetworksIndicatorData;
  public isLoading: boolean = true;

  constructor(private indicatorService: IndicatorService, private indicatorMediator: IndicatorMediator) {}

  async ngOnInit() {
    this.topTenNetworksData = (await this.indicatorMediator.getIndicatorData(new TopTenNetworksIndicatorDataStrategy())) as TopTenNetworksIndicatorData;
    this.isLoading = false;
  }

  public async onFilterData(company: Company) {
    this.isLoading = true;
    if (company) this.topTenNetworksData = await this.indicatorService.getTopTenNetworksData([company.getFiscalNumber()]);
    else this.topTenNetworksData = await this.indicatorService.getTopTenNetworksData();
    this.isLoading = false;
  }

  public getTopTenNetworksList() {
    return this.topTenNetworksData && this.topTenNetworksData.getItems();
  }

  public getNetworkName(netowrk): string {
    return netowrk.networkName;
  }

  public hasTopTenNetworksData(): boolean {
    return !!this.topTenNetworksData && !!this.topTenNetworksData.getItems().length;
  }

  public trackByFn = (index: number, item: any) => item.id;
}
